import axios from "axios";

const API = axios.create({
  baseURL: "https://registration.bilimbedigital.com/api",
  //baseURL: "http://localhost:7030/api",
});

API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});

export default API;